export default "__VITE_ASSET__h8Th0f_v__"